import React from 'react'
import './styles.scss'
import arrow from './../../images/arrow.svg'
import close from './../../images/close-white.svg'
const FaqBtn = () => {
    const openFaq = () => {
        document.getElementById('faq').classList.add("active");
    }

    const closeBtn = () => {
        document.getElementById('faqBtn').classList.add("disable");
    }
    return (
        <div id="faqBtn" className="faq-btn">
            <div className="box" onClick={() => openFaq()}>
                <img className="arrow" src={arrow} />
                <span>FAQ</span>
            </div>
            <div className="box" onClick={() => closeBtn()}>
                <img className="close" src={close} />
            </div>
        </div>
    )
}

export default FaqBtn;